module.exports = __webpack_public_path__ + "static/t24kc-2c379c736354ea916a7348d7e4e4abfc.png";